module.exports = __webpack_public_path__ + "a608ea94c686cec67493dca996a07f88.png";